import { CHECKIN_ROUTES } from '@conf/routes.config';

/**
 * フローティングナビを配置する画面のURL
 */
export const BOTTOM_FLOAT_URLS: BottomFloatUrlType[] = [
  {
    url: `/${CHECKIN_ROUTES.checkinSelect}`,
    float_height_pc: 70,
    float_height_tb: 70,
    float_height_sp: 62,
  },
  {
    url: `/${CHECKIN_ROUTES.passengerInput}`,
    float_height_pc: 70,
    float_height_tb: 70,
    float_height_sp: 62,
  },
  {
    url: `/${CHECKIN_ROUTES.seatmap}`,
    float_height_pc: 70,
    float_height_tb: 70,
    float_height_sp: 62,
  },
];

export interface BottomFloatUrlType {
  url: string;
  float_height_pc: number;
  float_height_tb: number;
  float_height_sp: number;
}
